import { render, staticRenderFns } from "./SwitchPlatformCard.vue?vue&type=template&id=963bdf1c&scoped=true&"
import script from "./SwitchPlatformCard.vue?vue&type=script&lang=js&"
export * from "./SwitchPlatformCard.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPlatformCard.vue?vue&type=style&index=0&id=963bdf1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963bdf1c",
  null
  
)

export default component.exports